// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UsbTwoToneSvg from "@ant-design/icons-svg/es/asn/UsbTwoTone";
import AntdIcon from '../components/AntdIcon';

var UsbTwoTone = function UsbTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: UsbTwoToneSvg
  }));
};

UsbTwoTone.displayName = 'UsbTwoTone';
export default React.forwardRef(UsbTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/UsbTwoTone.js
// module id = 2005
// module chunks = 0